<template>
  <div class="form tab-content">
    <input-field
      :value="pathwayIndex"
      :label="$tc('Pathway', 1)"
      inputType="other"
      size="small"
    >
      <treeselect
        v-model="pathwayIndex"
        :options="pathwaysList"
        :nornalizer="normalizer"
        class="form-input-select"
        disableFuzzyMatching
      />
    </input-field>

    <input-field value="" label="" inputType="" size="medium" />

    <input-field
      v-for="field in pathwayForm.fields"
      :key="field.label + field.order"
      :value="getValueInObject(field.var_name)"
      :label="field.label"
      :variable-name="field.var_name"
      :inputType="field.input_type"
      :size="field.size"
      :selectOptions="field.select_list_name"
      :radioOptions="field.radio_options"
      :fieldDisabled="true"
      :hide="field.hide"
    >
      <div v-if="field.input_type === 'checkbox'">
        <v-checkbox
          v-for="checkbox in field.checkbox_options"
          :key="checkbox.label"
          :label="checkbox.label"
          color="accent"
          :ripple="false"
          :disabled="true"
          v-model="pathwayData[checkbox.var_name]"
        />
      </div>
    </input-field>
  </div>
</template>

<script>
import InputField from "../_Molecules/InputField";
import _ from "lodash";
export default {
  name: "CablePathwaysSection",
  components: { InputField },

  props: {
    pathwaysData: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      pathwayIndex: undefined,
      pathwayData: {},

      pathwayForm: {}
    };
  },

  computed: {
    pathwaysList() {
      let pathwaysList = [];
      for (let i = 0; i < this.pathwaysData.length; i++) {
        let pathway = this.pathwaysData[i];
        let label = this.hasLabel(pathway) ? pathway.pw_label : pathway.pw_id;
        pathwaysList.push({ id: i, label: label });
      }
      return pathwaysList;
    },

    isPathwayUnderground() {
      return this.pathwayData.pw_instalation_type === "7";
    }
  },

  watch: {
    pathwayIndex(newValue) {
      if (newValue === undefined) {
        this.pathwayData = {};
      } else {
        this.pathwayData = this.pathwaysData[newValue];
      }
    },

    isPathwayUnderground() {
      this.updateInstallationTypeDependentFields();
    }
  },

  created() {
    this.structureAndPopulateForm();
  },

  methods: {
    hasLabel(pathway) {
      return pathway.pw_label !== null && pathway.pw_label !== "";
    },

    normalizer(node) {
      return {
        id: node.pw_id,
        label: node.pw_id
      };
    },

    /**
     * Gets the structure of the form from the backend and populates the objectData object.
     */
    structureAndPopulateForm() {
      this.loadingStructure = true;
      this.$store
        .dispatch("FETCH_OBJECT_FORM_STRUCTURE_BY_OBJECT_TYPE", {
          layer: "fc_pathway",
          needsTabs: true,
          needsFields: true
        })
        .then(formStructure => {
          this.pathwayForm = formStructure.tabs[0];
        });
    },

    /**
     * Gets the (nested) objectData corresponding to a string key, with a new value
     * @param {String} varName - path to the variable we're trying to access.
     */
    getValueInObject(varName) {
      return _.get(this.pathwayData, varName);
    },

    updateInstallationTypeDependentFields() {
      this.updateInstallationTypeDependentField("pw_material");
      this.updateInstallationTypeDependentField("pw_logical_type");
    },

    updateInstallationTypeDependentField(varName) {
      let fields = this.pathwayForm.fields;
      let dependentField = fields.find(field => field.var_name === varName);
      if (dependentField) {
        dependentField.hide = !this.isPathwayUnderground;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/CablePathwaysSection.vue